<section class="content-section gr-page">

  <!-- ── En-tête ─────────────────────────────────────────────────── -->
  <div class="gr-header">
    <div>
      <h2 class="gr-title">Gestion des rôles & permissions</h2>
      <span class="text-secondary">Configurez les menus accessibles pour chaque profil utilisateur</span>
    </div>
    <button type="button" class="gr-btn gr-btn--primary" (click)="ouvrirNouveauProfil()">
      <i class="fal fa-plus"></i> Nouveau profil
    </button>
  </div>

  <div *ngIf="chargement" style="text-align:center;padding:4rem;">
    <div class="gr-spinner"></div>
  </div>

  <!-- ── Panneau création / édition profil ──────────────────────── -->
  <div class="gr-overlay" *ngIf="panneauOuvert" (click)="fermerPanneau()"></div>
  <div class="gr-drawer" [class.gr-drawer--open]="panneauOuvert">
    <div class="gr-drawer-header">
      <h3>{{ modeEdition ? 'Modifier le profil' : 'Nouveau profil' }}</h3>
      <button type="button" class="gr-drawer-close" (click)="fermerPanneau()">
        <i class="fal fa-times"></i>
      </button>
    </div>
    <form [formGroup]="formProfil" class="gr-drawer-body" (ngSubmit)="soumettreFormProfil()">
      <div class="gr-field">
        <label>Code technique <span class="gr-required">*</span></label>
        <input type="text" formControlName="name" placeholder="ex: RESPONSABLE_STOCK"
               class="gr-input" [class.gr-input--error]="formProfil.get('name')?.invalid && formProfil.get('name')?.touched" />
        <small class="gr-hint">Majuscules et underscores uniquement (ex: LIVREUR_MOTO)</small>
      </div>
      <div class="gr-field">
        <label>Libellé affiché <span class="gr-required">*</span></label>
        <input type="text" formControlName="libelle" placeholder="ex: Livreur moto" class="gr-input" />
      </div>
      <div class="gr-field">
        <label>Description</label>
        <textarea formControlName="description" rows="2" class="gr-input" placeholder="Rôle et responsabilités..."></textarea>
      </div>
      <div class="gr-field">
        <label>Icône</label>
        <div class="gr-icones-grid">
          <button type="button" *ngFor="let ic of ICONES_DISPONIBLES"
                  class="gr-icone-btn"
                  [class.gr-icone-btn--active]="formProfil.get('icone')?.value === ic"
                  (click)="formProfil.get('icone')?.setValue(ic)">
            <i [class]="ic"></i>
          </button>
        </div>
      </div>
      <div class="gr-drawer-footer">
        <button type="button" class="gr-btn gr-btn--ghost" (click)="fermerPanneau()">Annuler</button>
        <button type="submit" class="gr-btn gr-btn--primary" [disabled]="formProfil.invalid">
          <i class="fal fa-save"></i> {{ modeEdition ? 'Enregistrer' : 'Créer le profil' }}
        </button>
      </div>
    </form>
  </div>

  <div *ngIf="!chargement" class="gr-layout">

    <!-- ── Colonne gauche : liste des rôles ──────────────────────── -->
    <div class="gr-roles-panel">
      <div class="gr-roles-list">
        <div *ngFor="let role of roles"
             class="gr-role-btn"
             [class.gr-role-btn--active]="roleSelectionne === role"
             (click)="roleSelectionne = role">
          <span class="gr-role-icon"><i [class]="role.icone || 'fal fa-user'"></i></span>
          <span class="gr-role-info">
            <strong>{{ role.libelle }}</strong>
            <span class="gr-role-count">{{ nbMenusAutorises(role) }} menus</span>
          </span>
          <div class="gr-role-actions">
            <button type="button" class="gr-role-action-btn" title="Modifier"
                    (click)="ouvrirEditionProfil(role, $event)">
              <i class="fal fa-pen"></i>
            </button>
            <button type="button" class="gr-role-action-btn gr-role-action-btn--danger" title="Supprimer"
                    (click)="supprimerProfil(role, $event)">
              <i class="fal fa-trash"></i>
            </button>
            <i class="fal fa-chevron-right gr-role-chevron"></i>
          </div>
        </div>

        <div *ngIf="roles.length === 0" class="gr-empty-roles">
          <i class="fal fa-users-slash"></i>
          <p>Aucun profil en base. Cliquez sur « Nouveau profil » pour commencer.</p>
        </div>
      </div>
    </div>

    <!-- ── Colonne droite : configuration du rôle sélectionné ────── -->
    <div class="gr-detail-panel" *ngIf="roleSelectionne">

      <!-- En-tête du rôle -->
      <div class="gr-detail-header">
        <div class="gr-detail-role-icon">
          <i [class]="roleSelectionne.icone || 'fal fa-user'"></i>
        </div>
        <div class="gr-detail-role-info">
          <h3>{{ roleSelectionne.libelle }}</h3>
          <p>{{ roleSelectionne.description || 'Aucune description' }}</p>
        </div>
        <div class="gr-detail-actions">
          <button type="button" class="gr-btn gr-btn--ghost" (click)="reinitialiserDefaut(roleSelectionne)"
                  title="Réinitialiser aux valeurs par défaut">
            <i class="fal fa-undo"></i> Défaut
          </button>
          <button type="button" class="gr-btn gr-btn--ghost" (click)="toutDecocher(roleSelectionne)">
            <i class="fal fa-times-circle"></i> Tout décocher
          </button>
          <button type="button" class="gr-btn gr-btn--ghost" (click)="toutCocher(roleSelectionne)">
            <i class="fal fa-check-circle"></i> Tout cocher
          </button>
          <button type="button" class="gr-btn gr-btn--primary" [disabled]="sauvegarde"
                  (click)="sauvegarderRole(roleSelectionne)">
            <i class="fal" [class.fa-save]="!sauvegarde" [class.fa-spinner]="sauvegarde"
               [class.fa-spin]="sauvegarde"></i>
            {{ sauvegarde ? 'Sauvegarde...' : 'Sauvegarder' }}
          </button>
        </div>
      </div>

      <!-- Sections de menus -->
      <div class="gr-sections">
        <div class="gr-section" *ngFor="let section of sections">
          <div class="gr-section-label">
            <span>{{ section }}</span>
            <span class="gr-section-count">{{ menusDeLaSection(section).length }}</span>
          </div>
          <div class="gr-menus-grid">
            <div class="gr-menu-item"
                 *ngFor="let menu of menusDeLaSection(section)"
                 [class.gr-menu-item--on]="estAutorise(roleSelectionne, menu.id)"
                 (click)="toggleMenu(roleSelectionne, menu.id)">
              <span class="gr-menu-icon"><i [class]="menu.icone"></i></span>
              <span class="gr-menu-nom">{{ menu.nom }}</span>
              <span class="gr-menu-toggle">
                <span class="gr-toggle" [class.gr-toggle--on]="estAutorise(roleSelectionne, menu.id)"></span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pied -->
      <div class="gr-detail-footer">
        <button type="button" class="gr-btn gr-btn--primary gr-btn--lg" [disabled]="sauvegarde"
                (click)="sauvegarderRole(roleSelectionne)">
          <i class="fal" [class.fa-save]="!sauvegarde" [class.fa-spinner]="sauvegarde" [class.fa-spin]="sauvegarde"></i>
          {{ sauvegarde ? 'Sauvegarde en cours...' : 'Sauvegarder les permissions — ' + roleSelectionne.libelle }}
        </button>
      </div>
    </div>

    <div class="gr-detail-panel gr-detail-panel--empty" *ngIf="!roleSelectionne && roles.length > 0">
      <i class="fal fa-hand-pointer"></i>
      <p>Sélectionnez un profil pour configurer ses accès</p>
    </div>

  </div>

</section>
